import { Component } from '@angular/core';

@Component({
  selector: 'tandem-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.css']
})
export class UnauthorizedComponent {

}
